import React, {useEffect, useRef, useState} from 'react';
import {Col, DatePicker, Form, Input, message, Row,} from 'antd';
import {ProForm, ProFormInstance} from '@ant-design/pro-form';
import {WdiCardTitle, wdiCore, WdiModalAppResult} from '@/components/WdiControls';
import {FormPageProps} from '@/components/WdiBus/FormPage';
import {ApplyFooter, ApplyFooterType} from '@/components/WdiBus/ApplyFooter';
import moment from 'moment';
import {FileUploadUtility, WdiFileUpload} from '@/components/WdiControls/WdiFileUpload';
import {PageType} from '@/services/basic/pagetype';
import {Enum} from '@/enums/system';
import {ResponseStatus} from '@/utils/request';
import {initApplyPageContext, ViewEntityProps} from '../../components/data';
import DataStore from '@/components/GridWidget/DataStore'
import FormSADetailsForApplyPanel from './details';
import SAWarningInfoApp from '../../components/WarningInformation';
import {FormSa, FormSaDetail} from '@/services/sales/sa';
import {ProjectToolTipApp} from '../../components/ProjectCmpt';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {WarningInfoAppProps} from '@/components/WdiBus/PanelForWarning';
import ProjectBudgetInfoPanel from '../../components/ProjectBudgetInfo';
import {BudgetProject} from '@/services/sales/bp/budgetProject';
import {WdiEditor} from "@/components/WdiControls/WdiEditor";

const { RangePicker } = DatePicker;

const getPageResult = (values: any, viewEntity: ViewEntityProps, pageType: API.PageType, statusId: number, dataSource: any[]) => {
  const result: WdiModalAppResult = { code: ResponseStatus.UNKNOWN };

  const { activityDate, fileInfo, isSpecialApprove, ...entity } = values;

  if (FileUploadUtility.isUploading(fileInfo)) {
    result.message = '附件正在上传中!';
    return result;
  }

  if (FileUploadUtility.isError(fileInfo)) {
    result.message = '附件存在错误文件!';
    return result;
  }

  const req: { form: any, formSa: any, formSaDetails: any[] } = {
    form: {
      statusId: statusId,
      pageTypeId: pageType.pageTypeId,
      pageGroupId: pageType.pageGroupId,
      formTypeId: viewEntity.formTypeId,
      budgetProjectId: viewEntity?.budgetProject?.budgetProjectId,
      userId: viewEntity?.userId,
      positionId: viewEntity?.positionId,
      isSpecialApprove: isSpecialApprove,
    },
    formSa: {},
    formSaDetails: [],
  };

  if (viewEntity.formId) {
    //草稿打开
    req.form.formId = viewEntity.formId;
  }
  else if (viewEntity.relatedFormId) {
    if (viewEntity.relationType === Enum.FormRelationType.REJECTED ||
      viewEntity.relationType === Enum.FormRelationType.MODIFIED) {
      // 退回待修改,修改单据
      req.form.formId = 0;
      req.form.relatedFormId = viewEntity.relatedFormId;
      req.form.relationType = viewEntity.relationType;
    }
    else if (viewEntity.relationType === Enum.FormRelationType.COPY) {
      //复制去掉相关单据
      req.form.formId = 0;
    }
    else {
      req.form.formId = 0;
    }

    entity.modifiedReason = '新建';
  }

  if (activityDate && activityDate.length == 2) {
    entity.activityStartDate = wdiCore.Date.DateToString(activityDate[0]);
    entity.activityEndDate = wdiCore.Date.DateToString(activityDate[1]);
  } else {
    result.message = "无效的活动日期";
    return result;
  }

  const info = FileUploadUtility.serialize(fileInfo);
  entity.fileName = info?.names;
  entity.filePath = info?.urls;

  req.formSa = entity;
  if (dataSource && dataSource.length) {
    dataSource.forEach((item, itemIndex) => {
      item.rowNumber = itemIndex + 1;
    });
  } else {
    result.message = "请填写申领信息!";
    return result;
  }

  req.formSaDetails = dataSource;
  result.data = req;
  result.code = ResponseStatus.SUCCESS;
  return result;
};

const FreeGoodsApplyApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();

  const [entity, setEntity] = useState<ViewEntityProps>();
  const [pageType, setPageType] = useState<API.PageType>();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [budgetProjectDetails, setBudgetProjectDetails] = useState<any[]>([]);
  const [warningSettings, setWarningSettings] = useState<WarningInfoAppProps>({ visible: false });
  const [editorRef,setEditorRef] = useState<any>();


  const onDetailsChange = (data: any) => {
    setDataSource(data);
  };

  useEffect(() => {
    (async () => {
      const params = props.data;
      if (params) {
        const result = await initApplyPageContext(params);

        if (result.code !== ResponseStatus.SUCCESS) {
          message.error(result.message);
          return;
        }
        const viewEntity: ViewEntityProps = result.data;

        if (viewEntity.form) {
          formRef.current?.setFieldsValue({
            isSpecialApprove: viewEntity.form.isSpecialApprove
          })
        }

        if (viewEntity.formSa) {
          formRef.current?.setFieldsValue({
            activityName: viewEntity.formSa.activityName,
            activityDate: [moment(viewEntity.formSa.activityStartDate), moment(viewEntity.formSa.activityEndDate)],
            remark: viewEntity.formSa.remark,
            fileInfo: FileUploadUtility.parse(viewEntity.formSa.fileName, viewEntity.formSa.filePath)
          });
        }

        if (viewEntity.budgetProject) {
          formRef.current?.setFieldsValue({
            project: viewEntity.budgetProject
          });
        }
        setEntity(viewEntity);

        if (viewEntity.pageTypeId) {
          PageType.get(viewEntity.pageTypeId).then((response) => {
            setPageType(response.data);
          });
        }

        if (viewEntity.budgetProjectId) {

          BudgetProject.getForDetails(viewEntity.budgetProjectId).then((response) => {
            setBudgetProjectDetails(DataStore.init(response.data));
          });
        }

        //获取明细,费用项改到明细内选取
        if (viewEntity.formSa) {
          FormSaDetail.getFgEx(viewEntity.formSa.formSaId || 0).then((response) => {
            setDataSource(DataStore.init(response.data));
          });
        }
      }
    })();
  }, [props.data]);

  useEffect(() => {
    if (props.setPageTitle && pageType && entity) {
      let title = "活动申请";

      if (entity.formSa) {
        title += '【编辑】'
      }
      props.setPageTitle(title);
    }
  }, [props.setPageTitle, pageType, entity]);

  return (
    <>
      <SAWarningInfoApp {...warningSettings} />
      <ProForm
        formRef={formRef}
        submitter={{
          render: () => {
            return (
              <ApplyFooter
                setLoading={props.setLoading}
                viewEntity={entity}
                submitBackUrl="/sales/sa/myactivity"
                doSubmit={async (type: number, forceSubmit: boolean) => {
                  if (!entity || !pageType || !dataSource) {
                    return;
                  }
                  const remark = await editorRef?.current?.getHtml?.();
                  const values = await formRef.current?.validateFieldsReturnFormatValue?.();
                  if (values && values.errorFields && values.errorFields.length) {
                    return;
                  }
                  const statusId = type === ApplyFooterType.Draft ? Enum.FormStatus.DRAFT : Enum.FormStatus.AWAITING;
                  values.remark = remark;
                  const req = getPageResult(values, entity, pageType, statusId, dataSource);
                  if (req.code !== ResponseStatus.SUCCESS) {
                    message.error(req.message);
                    return;
                  }
                  props?.setLoading?.(true);
                  if (type === ApplyFooterType.Validate) {
                    return await FormSa.Buttons.validate(req.data);
                  } else {
                    return await FormSa.Buttons.apply({
                      forceSubmit: forceSubmit,
                      ...req.data
                    });
                  }
                }}
                del={async () => {
                  if (!entity || !entity.formId) {
                    return;
                  }
                  return await FormSa.Buttons.del(entity.formId);
                }}
                showWarning={(result: WdiModalAppResult, submitCallback: any) => {
                  setWarningSettings({
                    visible: true,
                    title: "提示信息",
                    wdiPanelList: result.data,
                    onClose: () => {
                      setWarningSettings({ visible: false });
                    },
                    onSave: async () => {
                      return await submitCallback();
                    },
                  });
                }}
              />
            )
          }
        }}
      >
        <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.BASE_INFO} title='活动基本信息' />} >
          <Row gutter={[16, 24]}>
            <Col className="gutter-row" span={8}>
              <Form.Item name="activityName" label="活动名称" rules={[{ required: true, message: '活动名称不能为空!' }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={8}>
              <Form.Item required name="activityDate" label="活动期间" rules={[{ required: true, message: '活动期间不能为空!' }]}>
                <RangePicker />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item name="budgetProjectId" label="budgetProjectId" hidden>
                <Input />
              </Form.Item>
              <Form.Item name="project" label="专项项目">
                <ProjectToolTipApp />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col className="gutter-row" span={16}>
              <Form.Item name="remark" label="方案简述" rules={[{required: true, message: '方案简述不能为空!'}]}
              >
                <WdiEditor setRef={setEditorRef}/>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={8}>
              <Form.Item
                name="fileInfo"
                label="附件"
                valuePropName='fileList'
                getValueFromEvent={(e: any) => {
                  return e.fileList || [];
                }}
              >
                <WdiFileUpload leftTopInfo="请选择文件并上传(单个文件不能超500M)" multiple={true}/>
              </Form.Item>
            </Col>
          </Row>
        </WdiPanel>
        <ProjectBudgetInfoPanel dataSource={budgetProjectDetails} />
        <FormSADetailsForApplyPanel
          pid={props.id}
          data={{
            formSa: {
              pageTypeId: entity?.pageTypeId,
              formTypeId: entity?.formTypeId,
              budgetProjectId: entity?.budgetProjectId,
              bohqId:entity?.budgetProject?.bohqId
            }
          }}
          dataSource={dataSource}
          onChange={onDetailsChange}
        />
      </ProForm>
    </>
  );
};
export default FreeGoodsApplyApp;
